import React from 'react';
import { FormattedMessage } from 'react-intl';

import { OptionFormTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../../services/filtering/filter-form-render-service';
import type { CriteriaInformations } from '../../../../../../pages/products-page/purchase-orders/filter-options/types';
import { dateMessages } from './messages';

export const SHIP_DATES = 'shipDates';

export default {
  id: SHIP_DATES,
  displayName: () => <FormattedMessage {...dateMessages.shipDate} />,
  type: OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS,
  filterValue: SHIP_DATES,
  render: (criteriaInformations: CriteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS, criteriaInformations);
  },
};
